const jaTranslation = {
  // 共通
  app_name: '四柱推命',
  home: 'ホーム',
  login: 'ログイン',
  back: '戻る',
  next: '次へ',
  submit: '送信',
  cancel: 'キャンセル',
  required: '必須',
  cat_saju: 'K-ホーム',
  // メインページ
  fortune_categories: '占いカテゴリー',
  best_items: '人気の占い',
  all_categories: 'すべてのカテゴリー',
  favorites: 'お気に入り',
  history: '履歴',
  my_page: 'マイページ',
  tarot_new: '新登場！タロット占い',
  tarot_desc: '逆位置のカードも含む本格的なタロット占い',
  
  // カテゴリー
  cat_reunion: '復縁',
  cat_marriage: '結婚',
  cat_love: '恋愛',
  cat_compatibility: '相性',
  cat_newyear: '新年運勢',
  cat_career: '仕事',
  cat_trial: 'お試し占い',
  cat_free: '無料占い',
  cat_wealth: '金運',
  cat_tarot: 'タロット',
  cat_tarot_love: 'タロット恋愛',
  cat_tarot_future: 'タロット未来',
  cat_tarot_career: 'タロット仕事',
  best_items_saju: '人気の四柱推命',
  best_items_tarot: '人気のタロット',
  
  // 商品タイトル
  product_reunion_title: 'あの人ともう一度会えるのか？',
  product_compatibility_title: 'あの人との恋愛から結婚、そして相性は？',
  product_marriage_title: 'いつ結婚できるのか？',
  product_love_title: '私の恋愛運はどうなの？',
  product_newyear_title: '新年の運勢はどうなの？',
  product_career_title: '私の仕事運はどうなの？',
  product_wealth_title: '私の金運はどうなの？',
  product_tarot_love_title: 'タロットで見るあなたの恋愛',
  product_tarot_future_title: 'タロットで見るあなたの未来',
  product_tarot_career_title: 'タロットで見るあなたの仕事',
  
  // 商品詳細ページ
  product_detail_title: '商品詳細 - 四柱推命',
  original_price: '商品金額',
  discount_rate: '割引',
  final_price: '最終支払金額',
  buy_now: '購入する',
  product_details: '商品詳細',
  reviews: 'レビュー',
  product_includes: 'この鑑定には以下の内容が含まれます：',
  product_not_found: '商品が見つかりません',
  all_rights_reserved: '全ての権利を保有',
  
  // 商品説明
  product_reunion_desc: 'あなたの四柱推命を通じて、あの人との復縁の可能性を探ります。元恋人、古い友人、忘れられない縁との再会の可能性と時期をお伝えします。',
  product_marriage_desc: 'あなたの四柱推命を通じて、結婚の時期と配偶者の特性を分析します。いつ結婚できるか、配偶者の性格と特徴、結婚生活の姿をお伝えします。',
  product_love_desc: 'あなたの四柱推命を通じて、恋愛運と縁を分析します。現在の関係の状態、新しい縁が訪れる時期、あなたに合う理想のタイプをお伝えします。',
  product_compatibility_desc: '二人の四柱推命を通じて相性を分析します。恋愛相性、結婚相性、そして隠れた相性までをすべてお伝えします。',
  product_newyear_desc: 'あなたの四柱推命を通じて2025年の全体運勢を分析します。金運、健康運、仕事運、重要な時期などをお伝えします。',
  product_career_desc: 'あなたの四柱推命を通じて生まれ持った才能と適性に合う職業、キャリア成功の時期、昇進や転職に有利な時期を分析します。',
  product_wealth_desc: 'あなたの四柱推命を通じて金運を分析します。収入が増加する時期、支出に注意すべき時期、投資に有利な時期と分野をお伝えします。',
  
  // 生年月日入力ページ
  birth_info_title: '生年月日情報を入力してください',
  birth_info_desc: '正確な占いのために生年月日と時間を入力してください。',
  birth_date: '生年月日',
  birth_year: '年',
  birth_month: '月',
  birth_day: '日',
  birth_time: '生まれた時間',
  unknown_time: '時間不明',
  partner_info: 'パートナー情報',
  partner_birth_date: 'パートナーの生年月日',
  
  // 悩み入力ページ
  concern_title: '現在の記念日',
  concern_desc: '悩みや質問を入力してください（任意）',
  concern_placeholder: '悩みや質問を入力してください...',
  char_count: '文字',
  
  // 支払いページ
  payment_title: '支払い案内',
  payment_desc: '19,900円もお得になりました！',
  product_name: '商品名',
  product_price: '商品金額',
  coupon: 'クーポン',
  total_payment: '最終支払金額',
  max_discount: '最大割引が適用されました',
  coupon_change: 'クーポン変更',
  payment_method: '支払方法',
  card_payment: 'カード決済',
  bank_transfer: '銀行振込',
  agree_terms: '決済サービス利用規約、個人情報処理などに同意します',
  proceed_payment: '決済する',
  
  // 結果ページ
  result_title: '占い結果',
  result_desc: '入力された情報に基づいて占い結果をお知らせします。',
  
  // ログインページ
  login_with_google: 'Googleでログイン',
  login_desc: 'ログインすると占い結果を保存し、パーソナライズされたおすすめを受け取ることができます。',
  
  // 検証メッセージ
  validate_birth_date: '生年月日を全て入力してください。',
  validate_birth_time: '時間を入力するか、時間不明をチェックしてください。',
  validate_partner_birth: 'パートナーの生年月日を全て入力してください。'
};

export default jaTranslation;
